import { Component, OnInit, Injector, ChangeDetectionStrategy } from '@angular/core';
import { BaseComponents } from 'src/app/base.component';

@Component({
    selector: 'app-page-error',
    templateUrl: './page-error.component.html',
    styleUrls: ['./page-error.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PageErrorComponent extends BaseComponents implements OnInit {
  constructor(
    protected injectorObj: Injector,
  ){
    super(injectorObj);
  }

  ngOnInit(): void {
      
  }
}
